import styled, { css } from 'styled-components';

import Text from '~components/Text';
import { getFontStyle } from '~components/Text/helper';

export const S = {
  SalaryGrpahWrapper: styled.ul`
    display: grid;
    gap: 16px;
    grid-template-columns: 1fr 1fr;
    scroll-margin-top: 130px;

    min-height: 280px;
    margin-top: 30px;

    ${({ theme }) => theme.media.mobile} {
      grid-template-columns: auto;
      gap: 0;
    }
  `,
  Title: styled.p`
    font-weight: 700;
    font-size: 26px;
    line-height: 32px;
    color: ${({ theme }) => theme.colors.gray900};
    padding-top: 20px;
    padding-bottom: 10px;
  `,
  SubTitle: styled(Text)`
    color: ${({ theme }) => theme.colors.gray700};
  `,
  PointTitle: styled.span`
    color: ${({ theme }) => theme.colors.magenta700};
    font-weight: bold;
  `,

  Summary: styled.div`
    background: ${({ theme }) => theme.colors.gray200};
    border-radius: 4px;
    padding: 20px;
    margin-top: 30px;

    color: ${({ theme }) => theme.colors.gray900};
    ${getFontStyle('midium120_B2')};
    text-align: center;

    span {
      color: ${({ theme }) => theme.colors.blue500};
    }

    ${({ theme }) => theme.media.mobile} {
      padding: 20px 63px;
      word-break: keep-all;
    }
  `,

  SalaryGraph: styled.li`
    list-style: none;

    ${({ theme }) => theme.media.mobile} {
      &:first-child {
        margin-bottom: 30px;
      }
    }
  `,

  GraphCard: styled.div<{ paddingLeft?: string }>`
    padding: 32px;
    box-sizing: border-box;
    border: 1px solid rgb(235, 235, 235);
    border-radius: 4px;
    padding-left: ${(props) => props.paddingLeft};
    text-align: center;

    ${({ theme }) => theme.media.mobile} {
      width: 100%;
      max-width: none;
      position: relative;
      padding: 30px 20px;
      padding-left: ${(props) => props.paddingLeft};
    }
  `,
  ButtonWrapper: styled.div`
    padding-top: 30px;
  `,
  SalaryChartContainer: styled.div`
    padding-top: 30px;
  `,
  cssTitleBullet: css`
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  `,
  SalaryGreyBox: styled.div`
    border: 1px solid ${({ theme }) => theme.colors.gray400};
    border-radius: 4px;
    padding: 40px 0;

    ${({ theme }) => theme.media.mobile} {
      padding: 20px;
    }
  `,
  TooltipWrapper: styled.div`
    position: relative;
    margin-left: 5px;
  `,
};
